<template>
  <div class="manage_owner_component">
    <md-dialog :md-active.sync="manage_owners.show">
      <md-dialog-title>
        <md-dialog-title>
          Manage Owners
          <span class="md-caption">(ID: {{
              manage_owners.application && manage_owners.application.id
            }})</span>
        </md-dialog-title>
      </md-dialog-title>
      <div class="fixed-size-dialog-content">
        <group-card title="Existing Owners" icon="support_agent" padded>
          <table class="data-table wide">
            <thead>
            <tr>
              <td>Role</td>
              <td>Name</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in manage_owners.all_owners">
              <td>
                {{ user.role_name }}
              </td>
              <td :class="{ disabled: user.role_name === 'Referrer' && application_referrer.is_marketing_lead }">
                {{ user.name | name }}
                <span v-if="user.role_name === 'Referrer' && application_referrer.is_marketing_lead">
                  (not editable)
                </span>
              </td>
            </tr>
            </tbody>
          </table>
        </group-card>
          <group-card title="Update Owners" icon="update" padded>
            <md-field>
              <label for="owner_type">Owner Type</label>
              <md-select v-model="manage_owners.role" name="owner_type" id="owner_type" @change="resetFields">
                <md-option v-for="types in roles_types" v-bind:key="types" :value="types">
                  {{ types }}
                </md-option>
              </md-select>
            </md-field>
          <br/>
          <md-field>
            <md-input v-model="manage_owners.query">
            </md-input>
            <label>Users</label>
            <span class="md-suffix" v-if="isSearching">
                            <md-progress-spinner :md-diameter="30" :md-stroke="3"
                                                 md-mode="indeterminate"></md-progress-spinner>
                        </span>
          </md-field>
          <v-data-table
            v-if="manage_owners.results && manage_owners.query"
            :items="manage_owners.results"
            :headers="headers"
            hide-default-header
            item-key="id"
            @click:row="handleClick"
            hide-default-footer
            class="elevation-1"
          ></v-data-table>
          <md-button class="md-primary md-simple" @click="saveOwners" :disabled="isSaving && canUpdate">Save</md-button>
        </group-card>
      </div>
      <md-dialog-alert
        :md-active.sync="alertBox.status"
        :md-title="alertBox.message"
      />
      <md-progress-bar md-mode="indeterminate" v-if="isSaving"></md-progress-bar>
      <md-dialog-actions>
        <md-button class="md-primary md-simple" @click="onCloseOwnerComponent">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import filters from "@/components/utils/filters";
import {GroupCard} from "@/components";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconButton from '@/components/LoadingIconButton';

export default {
  components: {
    GroupCard,
    ...ValidatedInputs,
    LoadingIconButton,
  },
  props: {
    manage_owners: {
      type: null,
      default: () => null
    }
  },
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Email', value: 'email'},
      ],
      isSearching: false,
      isSaving: false,
      alertBox: {
        status: false,
        message: '',
        position: 'center',
        duration: 4000,
        isInfinity: false
      },
    }
  },
  computed: {
    ...mapGetters([
      'options',
      'user',
      'userHasPermission',
      'userHasRole',
      'application_referrer'
    ]),
    canUpdate() {
      return this.manage_owners.selected != null || this.userHasRole('super-admin');
    },
    roles_types() {
      if (this.application_referrer.is_marketing_lead) {
        return this.options.user_roles_types.filter(role => role !== 'Referrer');
      }
      return this.options.user_roles_types;
    }
  },
  filters: {
    ...filters,
  },
  methods: {
    onCloseOwnerComponent() {
      this.$store.commit('set_application_update_owners_dialog', null);
    },
    async saveOwners() {
      this.isSaving = true;

      try{
        let response = await axios.post(`/api/v1/application/${this.manage_owners.application.id}/add_multiple_owner`, {
          'owners': [this.manage_owners.selected],
          'owner_type': [this.manage_owners.role]
        });
        if (response) {
          this.alertBox.status = true;
          this.alertBox.message = 'Owners Saved';
          this.isSaving = false;
        } else {
          this.alertBox.status = true;
          this.alertBox.message = 'Error saving owners';
          this.isSaving = false;
        }
      }catch(error){
        console.error(error);
      }

      try{
        await this.getExistingOwners();
      }catch(error){
        console.error(error);
      }

      this.isSaving = false;
    },
    async getUserAndRoles() {

      if (this.manage_owners.query && this.manage_owners.role) {
        if (this.manage_owners.query.length > 2) {
          this.isSearching = true;
          let {data: users} = await axios.get(`/api/v1/administration/role_based_users/${this.manage_owners.query}/${this.manage_owners.role}`);
          this.manage_owners.results = users.filter(user => user.status_tag !== "Inactive");
        }
      }
      this.isSearching = false;
    },
    async getExistingOwners() {
      this.resetFields();
      let response = await axios.get(`/api/v1/application/${this.manage_owners.application.id}/get_existing_owners`);
      this.manage_owners.all_owners = response.data;
      this.$store.commit("application_referrer", response.data);
    },
    handleClick(user) {
      this.manage_owners.query = user.name;
      this.manage_owners.selected = user;
    },
    resetFields() {
      this.isSearching = false;
      this.manage_owners.query = "";
      this.manage_owners.role = null;
      this.manage_owners.selected = null;
      this.manage_owners.results = [];
    },
  },
  watch: {
    'manage_owners.show': {
      handler(show) {
        if (show) {
          this.getExistingOwners();
        }
      },
      deep: true,
      immediate: true,
    },
    'manage_owners.query'(){
      this.getUserAndRoles();
    },
    'manage_owners.role'(){
      this.getUserAndRoles();
    },
  },
  async beforeCreate() {
    const params = {
      types: [
        'user_roles_types',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
  created() {
  },
}

</script>
<style scoped>
.hint {
  padding: 15px;
}

.fixed-size-dialog-content {
  height: 600px;
  width: 600px;
  overflow-y: scroll;
}
</style>
<style lang="scss">
.md-menu-content {
  z-index: 999;
}

.disabled {
  color: grey;
  cursor: not-allowed;
}

</style>
